// The maximum cumulated size that can be handled by an export to PolyOffice, in bytes
export const POLYOFFICE_MAX_EXPORT_SIZE = 150 * 1024 * 1024
// The maximum size of a single file that can be handled by an export to PolyOffice, in bytes
export const POLYOFFICE_MAX_EXPORT_FILE_SIZE = 110 * 1024 * 1024
// The maximum number of files that can be handled by an export to PolyOffice
export const POLYOFFICE_MAX_EXPORT_FILE_COUNT = 30
